<template>
  <div class="flex flex-col">
    <div
      class="text-lg font-bold leading-tight"
      data-testid="partners-points-status-points"
    >
      {{ $t('partners-summary-points', { points: i18n.n(loyaltyPoints.points) }, loyaltyPoints.points) }}
    </div>
    <div
      v-if="spent"
      class="text-xs text-EXPONDO-grey-80"
      data-testid="partners-points-status-spent"
    >
      {{ $t('partners-summary-spent', { amount: spent }) }}
    </div>
  </div>
</template>

<script lang="ts">

import { formatNumberAsCurrency } from '~~/helpers/formatNumberAsCurrency';
import { formatLoyaltySpendings } from '~~/helpers/loyaltyPoints/formatLoyaltySpendings';
import type { LoyaltyPoints } from '~~/types/loyaltyPoints/loyaltyPoints';

export default defineComponent({
  name: 'PartnersPointsStatus',
  props: {
    loyaltyPoints: {
      type: Object as PropType<LoyaltyPoints>,
      required: true,
    },
  },
  setup(props) {

    const i18n = useI18n();

    const spent = computed(() => formatLoyaltySpendings(
      props.loyaltyPoints.spendings,
      ({ amount, currency }) => formatNumberAsCurrency(amount, { i18n, currencyCode: currency }),
    ));

    return {
      i18n,
      spent,
    };

  },
});

</script>
